import baseApi from '../utils/ApiUtils';

export const transfersApi= (method, payload = null, params = null) => {
  return baseApi(`/transfers/`, method, params, payload).then(response => {
    return response.data;
  });
};

export const transfersAction= (method, id, payload = null, params = null) => {
  return baseApi(`/transfers/${id}/`, method, params, payload).then(response => {
    return response.data;
  });
};

export const transfersActivityLog= (method, id, payload = null, params = null) => {
  return baseApi(`/transfers/${id}/activity_logs/`, method, params, payload).then(response => {
    return response.data;
  });
};

export const transfersTaskPoolService= (method, id, payload = null, params = null) => {
  return baseApi(`/transfers/${id}/task_pools/`, method, params, payload).then(response => {
    return response.data;
  });
};

export const transfersTransition= (method, id, payload = null, params = null) => {
  return baseApi(`/transfers/${id}/transition/`, method, params, payload).then(response => {
    return response.data;
  });
};

export const transferActivityLogService= (method, id, payload = null, params = null) => {
  return baseApi(`/transfers/${id}/activity_logs/`, method, params, payload).then(response => {
    return response.data;
  });
};
export const transferReportApi= (method, id, payload = null, params = null) => {
  return baseApi('reports/transfers/?format=csv', method, params, payload, 'blob').then(response => {
    return response.data;
  });
};